import { DollarSign, Clock, Phone, Truck, Route, Package } from 'lucide-react';

const benefits = [
  { icon: DollarSign, title: 'Competitive Rates', desc: 'Market-competitive compensation' },
  { icon: Clock, title: 'Prompt Payments', desc: 'Quick and hassle-free transactions' },
  { icon: Phone, title: '24/7 Support', desc: 'Always available to assist' },
  { icon: Truck, title: 'Advanced Tech', desc: 'Easy load finding tools' },
  { icon: Route, title: 'Extensive Network', desc: 'Access to nationwide loads' },
  { icon: Package, title: 'Backhaul Loads', desc: 'Maximize your efficiency' },
];

export const WhyPartnerSection = () => (
  <section className="py-16 bg-white border-t border-zinc-200">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-2xl sm:text-3xl font-black text-zinc-900">Why Partner With Us?</h2>
      </div>
      <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-6">
        {benefits.map((item) => (
          <div key={item.title} className="text-center p-6 border border-zinc-200 hover:border-red-200 hover:bg-red-50/50 transition-colors">
            <item.icon className="w-8 h-8 mx-auto mb-3 text-red-600" />
            <h3 className="font-bold text-zinc-900 mb-1">{item.title}</h3>
            <p className="text-xs text-zinc-500">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
